import axios from "axios";
import {
  API_BASE_URL,
  ASSUME_ROLE_ENABLED,
  API_AD_APP_SCOPE,
} from "@/helpers/config";
import { useAuthStore } from "@/stores/auth";
import { useUiStore } from "@/stores/ui";
import { storeToRefs } from "pinia";

export const http = axios.create({
  baseURL: `${API_BASE_URL}/v2`,
});

let pendingHttpRequests = 0;
function showOrHideLoadingIndicator(show) {
  if (show) pendingHttpRequests++;
  else pendingHttpRequests--;
  if (!show && pendingHttpRequests > 0) return;

  const $uiStore = useUiStore();
  const { isLoading } = storeToRefs($uiStore);
  isLoading.value = show;
}

// get an access token before each request
http.interceptors.request.use(async (config) => {
  config.headers["x-api-frontend-version"] = import.meta.env.PACKAGE_VERSION;

  const $authStore = useAuthStore();
  const { assumedRole } = storeToRefs($authStore);

  if (ASSUME_ROLE_ENABLED) {
    if (assumedRole.value != undefined) {
      config.headers["Assume-Role"] = assumedRole.value;
    }
  }

  await $authStore.initializeAuthentication();

  return $authStore.acquireTokenRedirect(API_AD_APP_SCOPE ?? "").then(
    (token) => {
      config.headers.Authorization = `Bearer ${token.accessToken}`;
      showOrHideLoadingIndicator(true);
      return config;
    },
    (err) => {
      console.error(err);
      return err;
    },
  );
});

http.interceptors.response.use(
  function (response) {
    showOrHideLoadingIndicator(false);
    return response;
  },
  function (error) {
    showOrHideLoadingIndicator(false);
    return Promise.reject(error);
  },
);
